export * from '@fhs/routing/src/routes/v2/offers/_layout';
export { default } from '@fhs/routing/src/routes/v2/offers/_layout';
